import { render, staticRenderFns } from "./fromReceivables.vue?vue&type=template&id=73a45e4f&scoped=true&"
import script from "./fromReceivables.vue?vue&type=script&lang=js&"
export * from "./fromReceivables.vue?vue&type=script&lang=js&"
import style0 from "./fromReceivables.vue?vue&type=style&index=0&id=73a45e4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a45e4f",
  null
  
)

export default component.exports